(function () {
  if (window.matchMedia('(pointer: coarse)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var glow = document.createElement('div');
  glow.id = 'cursor-glow';
  document.body.appendChild(glow);

  var targetX = 0, targetY = 0, currentX = 0, currentY = 0;
  var raf = null;

  function render() {
    currentX += (targetX - currentX) * 0.18;
    currentY += (targetY - currentY) * 0.18;
    glow.style.transform = 'translate3d(' + currentX + 'px,' + currentY + 'px,0)';
    raf = requestAnimationFrame(render);
  }

  window.addEventListener('mousemove', function (e) {
    targetX = e.clientX;
    targetY = e.clientY;
    glow.classList.add('is-active');
    if (!raf) {
      currentX = targetX;
      currentY = targetY;
      render();
    }
  }, { passive: true });

  window.addEventListener('mouseleave', function () {
    glow.classList.remove('is-active');
  });

  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && !e.toElement) {
      glow.classList.remove('is-active');
    }
  });
})();
